<template><zen-one 
    :showuserinfo="false" 
    :crumbs="crumbs"
    title="Sistem Hasil Bersepadu Kedah (iHasil)"
  >

    <z-page title="Butiran : Resit">

        <div class="message-box">
          <w-transition-fade>
            <w-alert
              class="my0 text-light"
              v-if="form.submitted"
              success
              no-border>
              The form is valid, ready to send it!
            </w-alert>

            <w-alert
              class="my0 text-light"
              v-else-if="form.valid === false"
              error
              no-border>
              Terdapat {{ form.errorsCount }} ralat di dalam borang ini.
            </w-alert>
          </w-transition-fade>
        </div>

        <w-form class="" v-model="form.valid" v-model:errors-count="form.errorsCount" @validate="onValidate" @success="onSuccess">
    
        <w-flex class="mt5">
            <div class="xs4">
                <h5 class="fw-semibold m0">
                      No Resit  :
                </h5>
                <div class="fw-normal my1 fs-1">
                    <template v-if="id == '1'">
                        2021000026 
                    </template>
                    <template v-else>
                        2021000023
                    </template>
                </div>
            </div>
            <div class="xs4">
                <h5 class="fw-semibold m0">
                     Tarikh Resit 
                </h5>
                <div class="fw-normal my1 fs-1">
                     <template v-if="id == '1'">
                        06/12/2021 
                    </template>
                    <template v-else>
                        20/09/2021
                    </template>
                 </div>
            </div>
            <div class="xs4">
                 <h5 class="fw-semibold m0">
                      Kaedah Bayaran  :
                </h5>
                <div class="fw-normal my1 fs-1">
                    <template v-if="id == '1'">
                        CEK
                    </template>
                    <template v-else>
                        BANK DERAF
                    </template>
                </div>
            </div>
        </w-flex>
        
        <w-flex class="mt3">
            
            <div class="xs4">
                <h5 class="fw-semibold m0">
                      No Cek/Bank Deraf :
                </h5>
                <div class="fw-normal my1 fs-1">
                    <template v-if="id == '1'">
                        676
                    </template>
                    <template v-else>
                        232323
                    </template>
                </div>
            </div>
            <div class="xs4">
                 <h5 class="fw-semibold m0">
                      Nama   :
                </h5>
                <div class="fw-normal my1 fs-1">
                     <template v-if="id == '1'">
                        BADAN PENGURUSAN BERSAMA PANGSAPURI RESAK | 0004 
                    </template>
                    <template v-else>
                        ABH TEKNOKRAT SDN BHD | 10
                    </template>
                </div>
            </div>
            <div class="xs4">
                 <h5 class="fw-semibold m0">
                      Status  :
                </h5>
                <div class="fw-normal my1 fs-1">
                    Aktif
                </div>
            </div>
        </w-flex>

        <w-flex class="mt3">
            
            <div class="xs6">
                <h5 class="fw-semibold m0">
                      Alamat :
                </h5>
                <div class="fw-normal my1 fs-1">
                    <template v-if="id == '1'">
                        NO. 1-G-MC, PANGSAPURI RESAK NO. 8 JALAN PULAU ANGSA U10/14 PERSIARAN PULAU CAREY 40150 
                    </template>
                    <template v-else>
                        NO. 84B, JALAN PELABUR A 23/A SEKSYEN 23 40300 SHAH ALAM 40000 
                    </template>
                </div>
            </div>
        </w-flex>

        <w-flex justify-center align-center class="table-hardcode">

            <div class="w-card__content content-hardcode mt3">
                <table class="table-dashboard" width="100%" >
                    <thead>
                        <tr>
                            <td>Bil</td>
                            <td>Kod Hasil</td>
                            <td>Butiran</td>
                            <td>Amaun Bayar (RM)</td>
                        </tr>
                    </thead>
                    <tbody>

                    <template v-if="id == '2'">
                        <tr>
                            <td align="center">1</td>
                            <td>H0173109 | JUALAN STICKER LESEN</td>
                            <td>TESTI </td>
                            <td rowspan="2"></td>
                        </tr>
                         <tr>
                            <td align="center">2</td>
                            <td>H0173108 | JUALAN BORANG LESEN</td>
                            <td>TESTING </td>
                        </tr>
                         <tr>
                            <td colspan="3" align="right">JUMLAH</td>
                            <td align="right">1,000.00</td>
                        </tr>
                        <tr>
                            <td colspan="3" align="right">PENGGENAPAN</td>
                            <td align="right">0.00</td>
                        </tr>
                        <tr>
                            <td colspan="3" align="right">JUMLAH PERLU DIBAYAR</td>
                            <td align="right">1,000.00</td>
                        </tr>
                    </template>
                    <template v-else>
                        <tr>
                             <td align="center"></td>
                            <td></td>
                            <td> </td>
                        </tr>
                         <tr>
                            <td colspan="3" align="right">JUMLAH</td>
                            <td align="right">0.00</td>
                        </tr>
                        <tr>
                            <td colspan="3" align="right">PENGGENAPAN</td>
                            <td align="right">0.00</td>
                        </tr>
                        <tr>
                            <td colspan="3" align="right">JUMLAH PERLU DIBAYAR</td>
                            <td align="right">0.00</td>
                        </tr>
                    </template>
                       
                    </tbody>
                </table>
            </div>

        </w-flex>

        <w-flex class="mt4" wrap align-center justify-end>
            <div class="spacer" />
            <w-button bg-color="success" class="mr3" @click="cetak()">
                <w-icon>fal fa-print</w-icon>
            </w-button>
            &nbsp;
            <w-button bg-color="error-dark1" class="mr3" @click="destroy(item)">
                <w-icon>fal fa-trash</w-icon>
            </w-button>
        </w-flex>

        </w-form>

        <w-notification v-model="form.sent" success transition="bounce"
          absolute
          plain
          round
          bottom>
          Borang telah berjaya dihantar
        </w-notification>

      </z-page>

  </zen-one>
</template>

<script>
import { reactive } from 'vue'

export default {
  components: {
    
  },
  props: {
    items: [Array, Object],
    id: [Array, Object, String],
  },
  data() {
    return {

    dialog: {
        show2: false,
        fullscreen: false,
        persistent: false,
        persistentNoAnimation: false,
        width: 500
  },
  form: {
    valid: null,
    submitted: false,
    sent: false,
    errorsCount: 0,
    kategori: '', 
    no:'',
  },
  validators: {
    required: value => !!value || 'This field is required',
    consent: value => !!value || 'You must agree'
  },
      resourceurl: 'deposit',
      reload: true,
      data: {
        permissions: [],
        roles: [],
      },
      crumbs: [
        { label: 'iHasil', route: '/' },
        { label: 'Kutipan', route: '/kutipan' },
        { label: 'Resir', route: '/kutipan/resit' },
        { label: 'Butiran', route: '/kutipan/' },
      ],
    }
  },
  methods: {
  cetak() {
            window.location.href = route('kutipan.terimaan.cetak');
        },
  
  },
  watch: {

  },
  mounted() {
    
      
  },
}
</script>